function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M31.255 12.522l-7.03-8.542a1.536 1.536 0 0 0-1.172-.564H10.387C8.174 3.388 6.36 5.3 6.333 7.686v25.626c.026 2.387 1.84 4.3 4.053 4.272h17.227c2.213.028 4.027-1.884 4.054-4.27V13.666a1.786 1.786 0 0 0-.412-1.145zm-9.088 13.103h-1.584v1.708c0 .944-.709 1.709-1.583 1.709s-1.583-.765-1.583-1.709v-1.708h-1.584c-.874 0-1.583-.765-1.583-1.708 0-.944.709-1.709 1.583-1.709h1.584V20.5c0-.943.709-1.708 1.583-1.708s1.583.765 1.583 1.708v1.708h1.584c.874 0 1.583.765 1.583 1.709 0 .943-.709 1.708-1.583 1.708zm1.124-11.958c-.68-.072-1.18-.719-1.124-1.452V6.833l5.921 6.834h-4.797z"
});

var SvgPaper = function SvgPaper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 38 41",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPaper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper.ddc1e445.svg";
export { ForwardRef as ReactComponent };